import { z } from 'zod';
/**
 * Phase 15b (15b-4) — operator admin compliance schemas. First schema file in
 * the `compliance/` resource dir (Convention 06). Backs
 * `POST /admin/compliance/run-scan`, which runs the daily compliance-expiry
 * scan on demand and returns the same tick summary the cron produces.
 */
export const ComplianceScanRunSummarySchema = z.object({
    /** ISO date (YYYY-MM-DD, America/Toronto) the scan treated as "today". */
    scanDate: z.string(),
    /** APPROVED + EXPIRED artifacts with an expiry date considered by the scan. */
    artifactsScanned: z.number().int().nonnegative(),
    /** Caregiver expiry alerts dispatched (after same-day dedup). */
    alertsFired: z.number().int().nonnegative(),
    /** Artifacts flipped APPROVED → EXPIRED this run. */
    autoExpiredCount: z.number().int().nonnegative(),
    /** Operator digest emails fanned out (0 when nothing is expiring). */
    digestDispatched: z.number().int().nonnegative(),
    /** Per-item failures isolated by try/catch (each emitted a scan.failed audit). */
    failuresCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=admin.schema.js.map